/* eslint no-unused-expressions: 0 */
import React from 'react';
import classNames from 'classnames';
import Button from './Button';
import { IDS_TO_COMMUNITIES, COMMUNITIES_TO_COLORS, COMMUNITIES_TO_NAMES,COMMUNITIES_TO_NAMES_SPANISH, IDS_TO_ORGCOUNT } from '../constants';
import { GAfireEvent } from './Tracking';
import { isEs } from "../libs/lang";
import { fireTag } from '../libs/analytics';

let communityNames = isEs() ? COMMUNITIES_TO_NAMES_SPANISH : COMMUNITIES_TO_NAMES;

const Filter = ({
					handleFilterClick,
					searchResultsByCategory,
					location,
					styles,
					activeID,
					isFiltered,
					expanded,
					isMap,
					defaultCommunity = false
				}) => {
	const communities = COMMUNITIES_TO_COLORS;

	const activeCategoryName = IDS_TO_COMMUNITIES[activeID];

	function convertCatNameToStylename(catName) {
		// remove all non-alphabetic chars
		let newCatStyleName = catName.replace(/[^A-Za-z/ ]/g, "").toLowerCase();
		// replace all spaces with hyphens
		newCatStyleName = `${newCatStyleName.replace(/ /g, "-")}-btn`;
		return newCatStyleName;
	}

	return (
		// eslint-disable-next-line jsx-a11y/role-supports-aria-props
		<div
			className={styles}
			id="filter-menu-dropdown"
			role="menu"
			data-active-category={activeCategoryName}
			data-categories-filtered={isFiltered}
			aria-expanded={expanded ? 'true' : 'false'}
			aria-hidden={expanded ? 'false' : 'true'}
		>


			{
				// if default community, move to first position in dropdown
				// render dropdown
				// Object.keys(communities).sort((x, y) => x === defaultCommunity ? -1 : y === defaultCommunity ? 1 : 0)


				// if default community, remove from dropdown.
				// Value will be default selected.
				// render dropdown
				Object.keys(communities).filter((community, y) => community !== defaultCommunity)
					.map((community, index, array) => {

						if (isMap === true) {
							let count, categoryID;
							if (location.pathname.indexOf('map') !== -1) { // on the Map page
								count = 0;
								if (searchResultsByCategory && searchResultsByCategory[community]) {
									count = searchResultsByCategory[community].length;
								}
								categoryID = convertCatNameToStylename(community);
							}
							else { // Not on Map Page
								count = IDS_TO_ORGCOUNT[community];
							}
							return (
								<div className="category-filter">
									<div className="category-spacer"/>
									<Button
										role="menuitem"
										key={COMMUNITIES_TO_COLORS[community]}
										handleClick={() => {
											fireTag("C8", communityNames[community].toLowerCase());
											//GAfireEvent('C32', {category: false, action: 'map page cause filter', label: communityNames[community]});
											handleFilterClick(community);
										}}
										buttonID={categoryID}
										tabIndex={expanded === false ? '-1' : '0'}
									>
										<div className={`swatch ${COMMUNITIES_TO_COLORS[community]}`}>
											{community === activeCategoryName && (
												<span className="list-item-checkmark">
                                    <div className="icon-checkmark"/>
                                  </span>
											)}
										</div>
										<div className={classNames('community', community === activeCategoryName ? 'selected' : '')}>{communityNames[community]}</div>
										<div className="count">{`${count} Orgs.`}</div>
										<div className="btn-on">
											<div className="community-selected">{communityNames[community]}</div>
										</div>
									</Button>
								</div>
							);
						}  // must be the HOME or ORG DETAIL page since NOT map
						return (
							<Button
								role="menuitem"
								key={communities[community]}
								handleClick={() => {
									//GAfireEvent('C32', {category: false, action: (location.pathname === '/sustainability/') ? 'map cause filter' : false, label: communityNames[community]});
									fireTag('C8', communityNames[community].toLowerCase());
									if(isEs()){
										window.location = window.location.origin + '/impact/map/?category=organizations-' + community.toLowerCase().replace(' ', '-');
									} else {
										handleFilterClick(community);
									}
								}}
								buttonStyles={communities[community]}
								tabIndex={expanded === false ? '-1' : '0'}
							>
								<span className={`swatch ${communities[community]}`}/>
								<span className="community">{communityNames[community]}</span>
							</Button>
						);


					}, this)
			}
		</div>
	);
};

export default Filter;
